import * as React from 'react';
import { Button } from '@mui/material';

const LeafContent = React.forwardRef(function LeafContent(props, ref) {

	const styleButton = {
      backgroundColor: 'transparent',
      color: "#406599",
      width: "150px",
      height: "45px",
      fontFamily: '"Roboto", "sans-serif"',
      fontSize: "16px",
      paddingLeft: "50px",
      justifyContent: "flex-start",
  	};

 const {
    label,
    onClick,
  } = props;

  let disable = (label !== "Download") ? true : false ;
  return (
    <div ref={ref}>
      <Button onClick={onClick} style={styleButton} disabled={disable}>
        {label}
      </Button>
    </div>
  );
});

export default LeafContent;
